import uuid from 'uuid/v1'
import { mapNamesToSubtestIds, answerLetters, } from './'

/**
 * Processes a record to add activities to the userAssessment. Part
 * of processing the the CSV upload for pencil and paper testing.
 * @param {object} uA the userAssessment we're adding activities to
 * @param {object} record row data from parsed csv
 * @param {string} studentId id of the student whose uA we're adding activities to
 * @param {object} items all of the contentItems in db 
 * @returns {object} userAssessment with activities added from record
 */
export default function addActivities(uA, record, studentId, items) {
  const subjects = ['English', 'Math', 'Reading', 'Science']
  const counts = {
    'English': 75,
    'Math': 60,
    'Reading': 40,
    'Science': 40,
  }
  const subtestIds = mapNamesToSubtestIds(uA)
  let activities = {}
  const timestamp = Date.now()
  subjects.forEach(subject => {
    const count = counts[subject]
    const subTestId = subtestIds[subject]
    const destructuredItems = uA.destructuredSubtests[subTestId].items
    activities[subTestId] = {}
    // for each question in the test, generate an activity
    for (let i = 1; i <= count; i++) {
      const studentResponse = record[`${subject}${i}`]
      const response = answerLetters[studentResponse] || ''
      const activityId = uuid()
      const itemId = destructuredItems[i - 1]
      const correct = !!(response && items[itemId].answers[response].correct)
      const grade = correct ? 1 : 0 
      const activity = {
        userId: studentId,
        verb: 'answered',
        activityId,
        userAssessmentId: uA.userAssessmentId,
        subTestId,
        itemId,
        response,
        timestamp,
        correct,
        grade,
      }
      activities[subTestId][activityId] = activity
    }
  })
  // return the uA with activities added in
  return {...uA, activity: activities}
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/addActivities.js